import * as Yup from 'yup';
export const setRequired = (valObj, is_required) => {
  if (typeof is_required !== 'undefined') {

    const reqVal =Yup.array().ensure().min(1, 'Must be at least 1');
    valObj = valObj.concat(reqVal);
  }
  return valObj;
};
export const checkAllowableSelections = (valObj, qObj) => {
  const checkUpTo = (valObj, qObj) => {
    return Yup.array().max(qObj.entry_count, 'Choose up to ' + (qObj.entry_count));
  };
  const checkExactly = (valObj, qObj) => {
    //Yup.array().length() produces unexpected results
    return Yup.array().min(qObj.entry_count, 'We suggest selecting exactly ' + qObj.entry_count).max(qObj.entry_count, 'Must be exactly ' + qObj.entry_count);
  };
  const checkMoreThan = (valObj, qObj) => {
    return Yup.array().min(qObj.entry_count, 'We suggest selecting at least ' + qObj.entry_count);
  };

  const devNull = (valObj) => {
    return valObj;
  };
  const criteriaTypes = {
    upto: checkUpTo,
    exactly: checkExactly,
    morethan: checkMoreThan,
    nolimit: devNull,
  };
  if (typeof qObj.entry_criteria !== 'undefined') {
    const checkValObj = criteriaTypes[qObj.entry_criteria](valObj, qObj);
    valObj = valObj.concat(checkValObj);
    return valObj;
  }
};
